<div
  class="flex items-center justify-center mobi-ui-ink-default"
  [class.h-0]="!!actions['#spaceless']"
  [class.relative]="!!actions['#spaceless']"
  [class.z-10]="!!actions['#spaceless']"
>
  <div class="flex items-center justify-center w-auto h-auto -m-[15px]">
    @if (steps?.length) {
      <div class="flex flex-col items-center lg:flex-row">
        @if (currentPage > 0 && !hidePrev) {
          <div class="p-[15px]">
            <button class="mobi-ui-btn-minor" (click)="goTo(currentPage - 1)">
              @if (prevLabel) {
                <span>
                  {{ prevLabel }}
                </span>
              } @else {
                {{ 'prev' | texts: { context: 'frontend', default: 'Zurück' } }}
              }
            </button>
          </div>
        }
        @if (currentPage < steps.length - 1 && !hideNext) {
          <div class="px-[15px]">
            <button class="mobi-ui-btn-major" (click)="goTo(currentPage + 1)">
              @if (nextLabel) {
                <span>
                  {{ nextLabel }}
                </span>
              } @else {
                {{ 'next' | texts: { context: 'frontend', default: 'Weiter' } }}
              }
            </button>
          </div>
        }
      </div>
    }
    @if (!hideSubmit) {
      <div class="px-[15px]">
        <button type="submit" class="mobi-ui-btn-major" (click)="submit()">
          {{ actions['#submit__label'] }}
        </button>
      </div>
    }
  </div>
</div>
